import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryReluctance: BlogMetaData = {
  title: '「保育園行きたくない」への対処法5選｜登園しぶりの原因をモンテッソーリ園の園長が解説',
  description:
    '「保育園行きたくない」と泣く子どもへの対処法5選。登園しぶり・登園拒否の原因を整理し、モンテッソーリ教育に基づく朝の声かけと家庭での関わり方をやさしく解説します。',
  thumbnailUrl: '/img/blog-nursery-reluctance.png',
  filePath: buildBlogFilePath('nursery-reluctance'),
  category: BLOG_CATEGORY.PARENTING,
};
